import { Record, Map as ImmutableMap } from 'immutable';
import { HISTORY_ACTION_TYPES as HistoryActionTypes } from 'automation-ui-log-events/api-client/constants/HistoryActionTypes';
import { NotificationTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { ActionOptions } from 'automation-ui-log-events/constants/ActionConstants';
import { ApplicationHistoryFilterKeys } from 'automation-ui-management/constants/ApplicationHistoryFilterKeys';
import { validateNotificationType, hasFiltersApplied } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { parseIntParams } from 'automation-ui-management/utils/recordUtils';
export const DefaultApplicationHistoryFilterProps = {
  [ApplicationHistoryFilterKeys.ACTION_ID]: ActionOptions.ALL,
  [ApplicationHistoryFilterKeys.ACTION_TYPE_ID]: HistoryActionTypes.ALL,
  [ApplicationHistoryFilterKeys.END_DATE]: undefined,
  [ApplicationHistoryFilterKeys.ERROR_TYPE]: undefined,
  [ApplicationHistoryFilterKeys.NOTIFICATION_TYPE]: NotificationTypes.ALL,
  [ApplicationHistoryFilterKeys.OBJECT_ID]: undefined,
  [ApplicationHistoryFilterKeys.RANGE_TYPE]: undefined,
  [ApplicationHistoryFilterKeys.REVISION_END_TIMESTAMP]: undefined,
  [ApplicationHistoryFilterKeys.REVISION_ID]: undefined,
  [ApplicationHistoryFilterKeys.REVISION_START_TIMESTAMP]: undefined,
  [ApplicationHistoryFilterKeys.START_DATE]: undefined
};
class ApplicationHistoryFilters extends Record(DefaultApplicationHistoryFilterProps, 'ApplicationHistoryFilters') {
  constructor(props = DefaultApplicationHistoryFilterProps) {
    let propMap = ImmutableMap(props);
    propMap = validateNotificationType(propMap);
    propMap = parseIntParams(propMap, [ApplicationHistoryFilterKeys.ACTION_ID, ApplicationHistoryFilterKeys.REVISION_START_TIMESTAMP, ApplicationHistoryFilterKeys.REVISION_END_TIMESTAMP, ApplicationHistoryFilterKeys.REVISION_ID, ApplicationHistoryFilterKeys.OBJECT_ID]);
    super(propMap);
  }
  getActionId() {
    return this.get(ApplicationHistoryFilterKeys.ACTION_ID);
  }
  getActionTypeId() {
    return this.get(ApplicationHistoryFilterKeys.ACTION_TYPE_ID);
  }
  getEndDate() {
    return this.get(ApplicationHistoryFilterKeys.END_DATE);
  }
  getNotificationType() {
    return this.get(ApplicationHistoryFilterKeys.NOTIFICATION_TYPE);
  }
  getObjectId() {
    return this.get(ApplicationHistoryFilterKeys.OBJECT_ID);
  }
  getRangeType() {
    return this.get(ApplicationHistoryFilterKeys.RANGE_TYPE);
  }
  getStartDate() {
    return this.get(ApplicationHistoryFilterKeys.START_DATE);
  }
  getRevisionId() {
    return this.get(ApplicationHistoryFilterKeys.REVISION_ID);
  }
  getRevisionStartTimestamp() {
    return this.get(ApplicationHistoryFilterKeys.REVISION_START_TIMESTAMP);
  }
  getRevisionEndTimestamp() {
    return this.get(ApplicationHistoryFilterKeys.REVISION_END_TIMESTAMP);
  }
  getErrorType() {
    return this.get(ApplicationHistoryFilterKeys.ERROR_TYPE);
  }
  hasFiltersApplied() {
    return hasFiltersApplied(this);
  }
}
export default ApplicationHistoryFilters;